<template>
  <ContainerFixed>
    <div class="ui segments raised">
      <CardTitle
        title="Status Certificado Digital"
        icon-class="file alternate outline icon"
        title-class="ui brown large ribbon label"
      >
      </CardTitle>
      <ContainerBody>
        <div class="fields">
          <Autocomplete
              label="Local"
              name="local"
              v-model="local"
              :items="listaFiliais"
              size="three"
            />
          <InputUpload
            ref="inputUpload"
            v-model="arquivo"
            type="text"
            name="certificadodigital"
            validation-rules="required"
            label="Certificado Digital"
            size="five"
            programa="scp111a1"
            :value="arquivo.nomeArquivo"
            :mostrarBotaoBaixar="false"
            :mostrarBotaoRemover="false"
            :mostrarBotaoEdicao="false"
          />
          <Input
            v-model="senha_certificado"
            type="password"
            name="senha_certificado"
            label="Senha Certificado"
            size="five"
            validation-rules="required"
          />
          <div class="three wide field">
            <BlankLabel />
                <button
                  type="button"
                  class="ui icon button green compact fluid "
                  @click="save"
                >
                  <i class="icon save" /> Salvar
                </button>
          </div>
        </div>
        <div class="sixteen wide column">
          <SimpleTable
            v-if="tableData.length"
            :headers="tableHead"
            :items="tableData"
          />
        </div>
      </ContainerBody>
    </div>
    <SimpleModal
      title="Importar Certificado Digital"
      :alerta="alertError"
    >
    </SimpleModal>
    <ModalAlert
      :title="alertTitle"
      :text="alertMessage"
      :erros="errors"
    />
  </ContainerFixed>
</template>

<script>

import ContainerFixed from '@/components/ContainerFixed.vue';
import ContainerBody from '@/components/ContainerBody.vue';
import CardTitle from '@/components/CardTitle.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import SimpleModal from '@/components/SimpleModal.vue';
import InputUpload from '@/components/InputUpload.vue';
import BlankLabel from '@/components/BlankLabel.vue';
import ModalAlert from '@/components/ModalAlert.vue';

import { ValidationObserver } from 'vee-validate';

import api from '@/services/api';
import moment from 'moment';

export default {
  name: 'ImportarCertificado',
  components: {
    ContainerFixed,
    ContainerBody,
    CardTitle,
    Autocomplete,
    SimpleTable,
    SimpleModal,
    Input,
    InputUpload,
    BlankLabel,
    ModalAlert,
  },
  data() {
    return {
      listaFiliais: [],
      dadosfiliais: [],
      tableHead: [
        { text: 'Código', value: 'codigo' },
        { text: 'Filial', value: 'abreviatura' },
        { text: 'Integração', value: 'provedor' },
        { text: 'Data validade', value: 'datavencimento' },
        { text: 'Dias até o vencimento', value: 'diasvencimento' },
        { text: 'Opções', value: 'buttons', buttons: true },
      ],
      tableData: [],
      alertError: '',
      modalConsulta: false,
      erroConsulta: '',
      local: null,
      resultadoConsulta: '',
      mostraIntegrar: false,
      theme: localStorage.getItem('theme') == 'dark' ? 'dark' : false,
      item: null,
      senha_certificado: null,
      arquivo: {
        nomeArquivo: '',
        idArquivo: '',
        recnumArqanex: 0,
      },
      alertMessage: '',
      alertTitle: 'Atenção',
      errors: [],
    };
  },
  async created() {
    await this.carregarCertificados();
  },
  mounted() {
    this.listarFiliais();
  },
  methods: {
    formatarData(value) {
      if (!value) {
        return '-';
      }
      const data = moment(value);
      return data.isValid() ? data.format('DD/MM/YYYY HH:mm:ss') : '-';
    },
    rotuloProvedor(usaNfseNacional) {
      return usaNfseNacional
        ? '<span class="ui teal mini label">NFS-e Nacional</span>'
        : '<span class="ui grey mini label">Manager</span>';
    },
    montarTabela(filiais) {
      return filiais.reduce((itens, item) => {
        const buttons = [
          { text: 'Importar', class: 'ui label green small', click: () => this.insereFilialAutoComplete(item.codigo) },
        ];
        itens.push({
          ...item,
          provedor: this.rotuloProvedor(item.usa_nfse_nacional),
          datavencimento: this.formatarData(item.datavencimento),
          diasvencimento: item.diasvencimento === null || item.diasvencimento === undefined ? '-' : item.diasvencimento,
          buttons,
        });
        return itens;
      }, []);
    },
    async carregarCertificados() {
      this.$store.commit('global/loading');
      try {
        const result = await api.get('api/filial/certificados');
        this.tableData = this.montarTabela(result.data || []);
      } catch (e) {
        this.tableData = [];
      } finally {
        this.$store.commit('global/loaded');
      }
    },
    insereFilialAutoComplete(codigo) {
      const filial = this.listaFiliais.find(item => Number(item.id) === Number(codigo));
      if (!filial) {
        this.$alertify.error('Local não encontrado na lista de filiais');
        return;
      }
      this.local = { ...filial };
      this.$refs.inputUpload.upload();
    },
    async listarFiliais() {
      this.$store.commit('global/loading');

      await api.get('/api/filiais')
        .then((result) => {
          const dados = result.data.reduce((itens, item) => {
            if (item.inativo.trim() === '' && item.soestoque !== 'S') {
              itens.push({ id: item.codigo, descricao: item.abreviatura, recnum: item.recnum });
            }
            return itens;
          }, []);
          this.listaFiliais = dados;
          this.$store.commit('global/loaded');
        });
    },
    nomeProvedor(provedor) {
      if (provedor === 'plugnotas') {
        return 'PlugNotas (NFS-e Nacional)';
      }
      if (provedor === 'manager') {
        return 'Manager';
      }
      return 'integração fiscal';
    },
    async save() {
      if (!this.local) {
        this.$alertify.error('É necessário selecionar o Local');
        return;
      }
      if (!this.arquivo.recnumArqanex) {
        this.$alertify.error('É necessário anexar o certificado digital');
        return;
      }
      if (!this.senha_certificado) {
        this.$alertify.error('É necessário inserir a senha do certificado');
        return;
      }
      this.errors = [];
      this.$store.commit('global/loading');
      try {
        const result = await api.put(`api/filial/${this.local.recnum}`, { senha: this.senha_certificado, recnum: this.arquivo.recnumArqanex });
        const dados = result.data || {};
        const provedor = this.nomeProvedor(dados.provedor);
        if (dados.erro) {
          this.alertTitle = 'Erro';
          this.alertMessage = dados.mensagem || `Erro ao atualizar o certificado no ${provedor}.`;
        } else {
          this.alertTitle = 'Atenção';
          this.alertMessage = dados.mensagem
            ? `${dados.mensagem} (${provedor})`
            : `Certificado atualizado no ${provedor}.`;
          await this.carregarCertificados();
        }
        this.$store.commit('global/openAlert');
      } catch (error) {
        this.alertTitle = 'Erro';
        this.alertMessage = '';
        if (error.response && error.response.data && error.response.data.errors) {
          this.alertTitle = 'Rejeitado';
          this.alertMessage = error.response.data.message;
          this.errors = Object.keys(error.response.data.errors).map(item => ({
            texto: error.response.data.errors[item].join(),
          }));
        } else if (error.response && error.response.data && error.response.data.mensagem) {
          this.alertMessage = error.response.data.mensagem;
        }
        this.$store.commit('global/openAlert');
      }
      this.$store.commit('global/loaded');
    },
  },
};
</script>

<style lang="scss">
  .box-json {

    .json {
      background-color: #282a36;
      color: #fff;
      white-space: break-spaces;
    }
  }
</style>
